import React from 'react';
import { Net } from '../net/Net.js';
import { NetRenderer } from '../net/NetRenderer.js';
import { TopBar } from './TopBar.js';
import { ColorFrame } from './ColorFrame.js';
import { COLORS, getRandomColorElement, toRGB } from '../utils/Color.js';
import { Database } from './Database';
import { VERSION, COPYRIGHT } from './Version.js'
import SSO from './SSO'

//import {Matrix} from '../net/Math.js'


import 'bootstrap/dist/css/bootstrap.css';
import './App.css';


const EPOCH = 1000


export default class App extends React.Component {


    constructor(props) {
        super(props)
        this.colorFrame = null
        this.user = null
        this.net = null
        this.database = new Database()
        this.trainingTimer = 0
        this.testTimer = 0
        this.nSharedTrainingData = 0
        this.nRandomTrainingData = 0
        this.nSharedTestData = 0
        this.nRandomTestData = 0
        this.target = []
        this.cumulatedError = 0
        this.epoch = 0
        this.truePositives = 0
        this.trueNegatives = 0

        this.state = {
            totalTrainingCount: 0,
            totalTestCount: 0,
            meanError: 0,
            currentError: 0,
            sensitivity: 0,
            specificity: 0,
            useSharedData: false,
            useRandomData: true,
            trainingSpeed: 3,
            learningRate: 1.0,
            showColorFrame: false,

            showBias: true,
            showGraph: true,
            showMatrix: true,
            precision: 2,
        }
    }


    componentDidMount() {
        this.user = { uid: 1, firstname: "", lastname: "", matrnr: "Algo 1" }
        // this.user = { uid: 1, firstname: "", lastname: "", matrnr: SSO.getUsername() }
        this.net = new Net([3, 15, 12])
        this.initNet()
    }


    // net configuration ----------------------------------------------------------------------------


    initNet() {
        let newLayers = []
        for (let l = 0; l < this.net.layers.length; l++) {
            newLayers.push(this.net.layers[l].neurons.length)
        }
        this.net = new Net(newLayers)
        this.resetNet()
    }


    deleteNetLayer(i, num) {
        let newLayers = []
        for (let l = 0; l < this.net.layers.length; l++) {
            if (l !== i) {
                newLayers.push(this.net.layers[l].neurons.length)
            }
        }
        this.net = new Net(newLayers)
        this.resetNet()
    }


    addNetLayer(nNeurons) {
        let num = Number(nNeurons)
        if (isNaN(num)) {
            window.alert("Not a number")
            return
        }
        if (num <= 0 || num > 25) {
            window.alert("Invalid number (too low or too large)")
            return
        }

        let newLayers = []
        let nOutputLayer = this.net.layers[this.net.layers.length - 1].neurons.length
        for (let l = 0; l < this.net.layers.length - 1; l++) {
            newLayers.push(this.net.layers[l].neurons.length)
        }
        newLayers.push(num)
        newLayers.push(nOutputLayer)
        this.net = new Net(newLayers)
        this.resetNet()
    }


    updateNetLayer(i, num) {
        let newNeurons = Number(num)
        if (isNaN(newNeurons)) {
            window.alert("Not a number")
            return
        }
        if (newNeurons <= 0 || newNeurons > 25) {
            window.alert("Invalid number (too low or too large)")
            return
        }
        let newLayers = []
        for (let l = 0; l < this.net.layers.length; l++) {
            newLayers[l] = (i === l ? newNeurons : this.net.layers[l].neurons.length)
        }
        this.net = new Net(newLayers)
        this.resetNet()
    }


    // training controls -------------------------------------------------------------------------------


    setLearningRate(rate) {
        this.setState({ learningRate: rate })
    }


    setTrainingSpeed(speed) {
        this.setState({ trainingSpeed: speed })
        if (this.trainingTimer > 0) {
            clearInterval(this.trainingTimer)
            this.trainingTimer = 0
            this.startTraining(speed)
        }
        if (this.testTimer > 0) {
            clearInterval(this.testTimer)
            this.testTimer = 0
            this.startTest(speed)
        }
    }


    setTrainingData(useShared, useRandom) {
        this.setState({
            useSharedData: useShared,
            useRandomData: useRandom
        })
    }


    // net quality --------------------------------------------------------------------------------------

    calculateLoss(target) {
        let sum = 0
        let outputLayer = this.net.layers[this.net.layers.length - 1]
        for (let i = 0; i < outputLayer.neurons.length; i++) {
            if (target[i] > 0.9999999) {
                sum = Math.abs(outputLayer.neurons[i] - target[i])
                break
            }
        }
        //this.setState({currentError: sum})

        if (this.epoch === EPOCH) {
            this.epoch = 1
            this.cumulatedError = 0
        }
        this.cumulatedError += sum
        this.setState({ meanError: this.cumulatedError / this.epoch })
    }



    calculateSensitivity(target) {
        let outputLayer = this.net.layers[this.net.layers.length - 1]
        let outputMaxIndex = 0
        let targetMaxIndex = 0
        for (let i = 1; i < outputLayer.neurons.length; i++) {
            if (outputLayer.neurons[i] > outputLayer.neurons[outputMaxIndex]) {
                outputMaxIndex = i
            }
            if (target[i] > 0.9999999) {
                targetMaxIndex = i
            }
        }
        if (outputMaxIndex === targetMaxIndex) {
            if (outputLayer.neurons[outputMaxIndex] > 0.5)
                this.truePositives++
            else
                this.truePositives += 0.5
        }
        this.setState({ sensitivity: this.truePositives / (this.nSharedTestData + this.nRandomTestData) })
        return targetMaxIndex
    }



    calculateSpecificity(target, targetMaxIndex) {
        let outputLayer = this.net.layers[this.net.layers.length - 1]
        let count = 0
        //console.log("----")
        for (let i = 0; i < outputLayer.neurons.length; i++) {
            if (i !== targetMaxIndex) {
                if (outputLayer.neurons[i] < 0.5) {
                    count++
                    //			console.log("count", count, i, outputLayer.neurons[i], COLORS[i])
                }

            }
        }
        //console.log("old ", this.trueNegatives, (outputLayer.neurons.length - 1))
        this.trueNegatives += count / (outputLayer.neurons.length - 1)
        //console.log("true neg", this.trueNegatives)
        this.setState({ specificity: this.trueNegatives / (this.nSharedTestData + this.nRandomTestData) })
    }



    // net controls --------------------------------------------------------------------------------------

    resetNet() {
        this.stopTraining()
        this.stopTest()
        this.trueNegatives = 0
        this.truePositives = 0
        this.trainingTimer = 0
        this.testTimer = 0
        this.nSharedTrainingData = 0
        this.nRandomTrainingData = 0
        this.nSharedTestData = 0
        this.nRandomTestData = 0
        this.setState({ totalTrainingCount: 0, totalTestCount: 0, meanError: 0, sensitivity: 0, specificity: 0, currentError: 0 })
        this.target = []
        this.cumulatedError = 0
        this.epoch = 0
        this.truePositives = 0
        this.incorrectTests = 0
    }


    getBundle(speed) {
        let bundle = 1
        if (speed === 4)
            bundle = 5
        else if (speed === 5)
            bundle = 10
        return bundle
    }


    doTraining(singleStep, speed) {
        this.stopTest()
        this.nSharedTestData = 0
        this.nRandomTestData = 0
        this.trueNegatives = 0
        this.truePositives = 0
        this.incorrectTests = 0
        this.setState({ sensitivity: 0, specificity: 0, totalTestCount: 0 })
        let elem = undefined
        let bundle = 1
        if (!singleStep) {
            bundle = this.getBundle(speed)
        }
        else {
            if (this.trainingTimer > 0) {
                this.stopTraining()
            }
        }
        for (let i = 0; i < bundle; i++) {
            elem = this.getNextTrainingData()
            this.epoch++
            if (elem !== undefined) {
                let rgb = toRGB(elem.hexColor)
                this.target = this.createOutputVector(12, elem.label)
                this.net.feedForward([rgb.r / 255.0, rgb.g / 255.0, rgb.b / 255.0]);
                this.net.computeDeltas(this.target)
                this.net.propagateBack(this.state.learningRate);
                this.calculateLoss(this.target)
            }
        }
        if (elem === undefined) {
            alert("No more training data.")
            this.stopTraining()
        }
        else {
            this.setState({
                totalTrainingCount: this.nSharedTrainingData + this.nRandomTrainingData,
            })
        }
        return (elem !== undefined)
    }


    doTest(singleStep, speed) {
        this.stopTraining()
        let elem = undefined

        let bundle = 1
        if (!singleStep) {
            bundle = this.getBundle(speed)
        }
        else {
            if (this.testTimer > 0) {
                this.stopTest()
            }
        }
        for (let i = 0; i < bundle; i++) {
            elem = this.getNextTestData()
            if (elem !== undefined) {
                let rgb = toRGB(elem.hexColor)
                this.target = this.createOutputVector(12, elem.label)
                this.net.feedForward([rgb.r / 255.0, rgb.g / 255.0, rgb.b / 255.0]);

                let max = this.calculateSensitivity(this.target)
                this.calculateSpecificity(this.target, max)
            }
        }
        if (elem === undefined) {
            alert("No more test data.")
            this.stopTest()
        }
        else {
            this.setState({
                totalTestCount: this.nSharedTestData + this.nRandomTestData,
            })
        }
        return (elem !== undefined)
    }


    getMS(speed) {
        let ms = 10
        switch (speed) {
            case 1: ms = 100; break
            case 2: ms = 20; break
            default: ms = 10;
        }
        return ms
    }


    startTraining(speed) {
        if (this.trainingTimer === 0) {
            if (this.doTraining(false, speed)) {
                this.trainingTimer = setInterval(() => this.doTraining(false, speed), this.getMS(speed))
            }
        }
    }


    stopTraining() {
        clearInterval(this.trainingTimer)
        this.trainingTimer = 0
        this.setState({
            totalTrainingCount: this.nSharedTrainingData + this.nRandomTrainingData,
        })
    }


    startTest(speed) {
        if (this.testTimer === 0) {
            if (this.doTest(false, speed)) {
                this.testTimer = setInterval(() => this.doTest(false, speed), this.getMS(speed))
            }
        }
    }


    stopTest() {
        clearInterval(this.testTimer)
        this.testTimer = 0
        this.setState({
            totalTestCount: this.nSharedTestData + this.nRandomTestData,
        })
    }


    getNextTrainingData() {
        let elem = undefined
        if (this.state.useSharedData) {
            elem = this.colorFrame.getNextTrainingData(this.nSharedTrainingData)
        }
        if (elem !== undefined) {
            this.nSharedTrainingData++
        }
        else {
            if (this.state.useRandomData) {
                this.nRandomTrainingData++
                elem = getRandomColorElement()
            }
        }
        return elem
    }


    getNextTestData() {
        let elem = undefined
        if (this.state.useSharedData) {
            elem = this.colorFrame.getNextTestData(this.nSharedTestData)
        }
        if (elem !== undefined) {
            this.nSharedTestData++
        }
        else {
            if (this.state.useRandomData) {
                this.nRandomTestData++
                elem = getRandomColorElement()
            }
        }
        return elem
    }


    createOutputVector(nLen, expectedValue) {
        let output = [];
        for (let i = 0; i < nLen; i++) {
            output[i] = (i === expectedValue ? 1.0 : 0.0);
        }
        return output;
    }


    // render methods ----------------------------------------------------------------------------------


    renderMainFrame() {
        return (
            <div className="MainFrame">
                <div className="LeftFrame" style={{ width: (this.state.showColorFrame ? "var(--leftFrameWidth)" : "0px") }}>
                    <ColorFrame
                        app={this}
                        database={this.database}
                        user={this.user}
                        showColorFrame={this.state.showColorFrame}
                    />
                </div>
                <div className="RightFrame" style={{ width: (this.state.showColorFrame ? "calc(100% - var(--leftFrameWidth))" : "100%") }}>
                    <TopBar
                        app={this}
                        user={this.user}
                        trainingCount={this.state.totalTrainingCount}
                        testCount={this.state.totalTestCount}
                        sensitivity={this.state.sensitivity}
                        specificity={this.state.specificity}
                        meanError={this.state.meanError}
                        currentError={this.state.currentError}
                        learningRate={this.state.learningRate}
                        trainingSpeed={this.state.trainingSpeed}
                        useSharedData={this.state.useSharedData}
                        useRandomData={this.state.useRandomData}
                    />
                    <div className="GraphFrame">
                        <NetRenderer
                            id={"NET_RENDERER"}
                            net={this.net}
                            app={this}
                            showBias={this.state.showBias}
                            showGraph={this.state.showGraph}
                            showMatrix={this.state.showMatrix}
                            precision={this.state.precision}
                        />
                    </div>
                </div>
            </div>
        )
    }


    renderNetControls() {
        return (
            <div className="LeftMenu">
                <div className="LeftMenuTop">
                    <div
                        className="Play"
                        style={{ top: '3px' }}
                        onClick={() => this.setState({ showColorFrame: !this.state.showColorFrame })}>
                        <img src="btn_color.png" width='26px' height='26px' alt='Colors'></img>
                    </div>

                    <div className="LeftMenuSpace"></div>
                    <div className="LeftMenuText">
                        Training
                    </div>
                    <div className="Play" onClick={() => this.doTraining(true, 0)}>
                        <img src="btn_step.png" width='26px' height='26px' alt='Step'></img>
                    </div>
                    {this.trainingTimer === 0 ?
                        <div className="Play" onClick={() => this.startTraining(this.state.trainingSpeed)}>
                            <img src="btn_play.png" width='26px' height='26px' alt='Run'></img>
                        </div> :
                        <div className="Play" onClick={() => this.stopTraining()}>
                            <img src="btn_pause.png" width='26px' height='26px' alt='Stop'></img>
                        </div>
                    }

                    <div className="LeftMenuSpace"></div>
                    <div className="LeftMenuText">
                        Test
                    </div>
                    <div className="Play" onClick={() => this.doTest(true, 0)}>
                        <img src="btn_step.png" width='26px' height='26px' alt='Test'></img>
                    </div>
                    {this.testTimer === 0 ?
                        <div className="Play" onClick={() => this.startTest(this.state.trainingSpeed)}>
                            <img src="btn_play.png" width='26px' height='26px' alt='Run'></img>
                        </div> :
                        <div className="Play" onClick={() => this.stopTest()}>
                            <img src="btn_pause.png" width='26px' height='26px' alt='Stop'></img>
                        </div>
                    }

                    <div className="LeftMenuSpace"></div>
                    <div className="LeftMenuText">
                        Reset
                    </div>
                    <div className="Play" onClick={() => this.initNet()}>
                        <img src="btn_reset.png" width='26px' height='26px' alt='Reset'></img>
                    </div>
                </div>
                <div className="LeftMenuBottom">
                </div>
            </div>
        )
    }


    renderSSOLogin() {
        return (
            <div className="LoginFrame">
                <div className="LoginInfo">
                    <div className="EasyCode">
                        neural.<font color='#0074C2'>net</font>
                    </div>
                    <div className="LoginText">
                        online vizualization platform<br />for simple neural networks
                    </div>
                    <div className="LoginSSO" onClick={() => SSO.doLogin()}>
                        &#9654; &nbsp;Login via SSO
                    </div>
                </div>
            </div>
        )
    }


    renderNoConnection() {
        return (
            <div className="LoginFrame">
                <div className="TopBar">
                    <div className="TopBarInfo">
                        Version {VERSION} &copy; {COPYRIGHT}
                    </div>
                </div>
                <div className="LoginInfo">
                    <div className="EasyCode">
                        neural.<font color='#0074C2'>net</font>
                    </div>
                    <div className="LoginText">
                        online vizualization platform<br />for simple neural networks
                    </div>
                    <div className="Error">
                        Connecting to database
                    </div>
                    <div>
                        ...
                    </div>
                </div>
            </div>
        )
    }


    render() {
        // if (this.props.ssoLogin) {
        //     return this.renderSSOLogin()
        // }
        if (this.user !== null) {
            return (
                <div className="Application">
                    {this.renderNetControls()}
                    {this.renderMainFrame()}
                    <div className="StatusBar">
                        &nbsp;&nbsp;neural.net - Version {VERSION} - &copy; {COPYRIGHT}
                    </div>
                </div>
            )
        }
        return this.renderNoConnection()
    }


}